<template>
  <div class="content">
    <h1>{{ t('notFound') }}</h1>
    <Button @click="router.push({ name: 'dashboard' })" :label="t('goToDashboard')" />
  </div>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'

definePage({
  name: '404',
  meta: {
    doesNotRequireAuth: true
  }
})

const router = useRouter()
const { t } = useI18n()
</script>

<style scoped>
.content {
  text-align: center;
  align-content: center;
  height: 100vh;
}
</style>

<i18n lang="yaml">
en:
  notFound: 'page not found'
  goToDashboard: 'Go to Dashboard'
nl:
  notFound: 'pagina niet gevonden'
  goToDashboard: 'Ga naar Dashboard'
de:
  notFound: 'seite nicht gefunden'
  goToDashboard: 'Zum Dashboard'
</i18n>
